export default __webpack_public_path__ + "static/media/soy-sensible-soy-social.4529071b.jpg";